export enum TipoPermissaoUsuario {
  Provedores = 'Provedores',
  Contratos = 'Contratos',
  Importacoes = 'Importações',
  Beneficiarios = 'Beneficiários',
  Integracoes = 'Integrações',
  EstruturaDaEmpresa = 'Estrutura Da Empresa',
  Faturas = 'Faturas',
}
